import {
	CloseReason,
	CustomRxEventType,
	RxCompleteData,
	RxExtensionCloseData,
	RxInitData,
	RxStatusData,
	RxUIReadyData,
	TokenRefreshRequestData,
	TokenRefreshResponseData
} from '../models/lab-broker-event.model';

export enum LabBrokerViewState {
	Inactive = 'inactive',
	Loading = 'loading',
	Active = 'active',
	Completed = 'completed',
	Error = 'error',
	Closing = 'closing',
	Unavailable = 'unavailable'
}

export interface LabBrokerConfig {
	iframeUrl: string;
	integratorName: string;
	/** Partner name for BI events: continueToNameText, or the selected lab name when it is empty. */
	partnerName: string;
	rxTemplate: string;
	labCompanyId: number;
}

export interface LabBrokerEventSnapshot<T = unknown> {
	data: T;
	timestamp: Date;
}

export interface LabBrokerState {
	viewState: LabBrokerViewState;
	config: LabBrokerConfig | null;

	lastReceivedEvent: {
		[CustomRxEventType.RxUIReady]?: LabBrokerEventSnapshot<RxUIReadyData>;
		[CustomRxEventType.RxComplete]?: LabBrokerEventSnapshot<RxCompleteData>;
		[CustomRxEventType.TokenRefreshRequest]?: LabBrokerEventSnapshot<TokenRefreshRequestData>;
		[CustomRxEventType.RxStatus]?: LabBrokerEventSnapshot<RxStatusData>;
	};

	lastSentEvent: {
		[CustomRxEventType.RxInit]?: LabBrokerEventSnapshot<RxInitData>;
		[CustomRxEventType.TokenRefreshResponse]?: LabBrokerEventSnapshot<TokenRefreshResponseData>;
		[CustomRxEventType.RxExtensionClose]?: LabBrokerEventSnapshot<RxExtensionCloseData>;
	};

	fullCustomRxPayload: RxCompleteData['FullCustomRx'] | null;

	errorMessage: string | null;

	dentiraUnavailableDialogSuppressed: boolean;

	/** Pending close reason when closing flow is in progress */
	pendingCloseReason: CloseReason | null;
}

export const createInitialLabBrokerState = (): LabBrokerState => ({
	viewState: LabBrokerViewState.Inactive,
	config: null,
	lastReceivedEvent: {},
	lastSentEvent: {},
	fullCustomRxPayload: null,
	errorMessage: null,
	dentiraUnavailableDialogSuppressed: false,
	pendingCloseReason: null
});
